'use client'

import React from 'react'
import Image from 'next/image'
import { useRouter } from 'next/navigation'
import { useModal } from '@/blocks/redesign_blocks/Modal/ModalContext'
import AnimatedSection from '@/components/AnimatedSection'
import styles from './styles.module.css'

interface ServiceItem {
  image: string
  title: string
  description: string
}

const Services: React.FC = () => {
  const router = useRouter()
  const { openProjectModal } = useModal()

  const services: ServiceItem[] = [
    {
      image: '/images/complex-solutions/services_1.svg',
      title: 'Для государства',
      description: 'Разрабатываем масштабные цифровые платформы для государственного сектора и отраслевых агентств. Проектируем системы государственного значения с высокой степенью безопасности и отказоустойчивости.'
    },
    {
      image: '/images/complex-solutions/services_2.svg',
      title: 'Для бизнеса',
      description: 'Создаем управляемые B2B и B2C экосистемы, которые объединяют продажи, логистику и финансы в единый цифровой контур. Вы получаете фундамент для роста, где каждый процесс оцифрован и прозрачен.'
    }
  ]

  const handleButtonClick = (index: number) => {
    if (index === 0) {
      // Первая карточка (Для государства) - открыть модалку
      openProjectModal()
    } else if (index === 1) {
      // Вторая карточка (Для бизнеса) - перейти на страницу fintech
      router.push('/services/fintech')
    }
  }

  return (
    <section className={styles.section}>
      <AnimatedSection animation="slideUp">
        <div className={styles.heading}>
          <div className={styles.subtitle}>Услуги</div>
          <h2 
            className={styles.title}
            dangerouslySetInnerHTML={{ __html: '<span>Цифровые экосистемы</span><br> для государства и бизнеса' }}
          />
        </div>
      </AnimatedSection>

      <AnimatedSection animation="slideUp">
        <div className={styles.grid}>
          {services.map((item, idx) => (
            <div key={idx} className={styles.card}>
              <div className={styles.imageContainer}>
                <Image
                  src={item.image}
                  alt={item.title}
                  width={460}
                  height={178}
                  className={styles.image}
                />
              </div>
              <div className={styles.content}>
                <h3 className={styles.cardTitle}>
                  {item.title}
                </h3>
                <p className={styles.cardDescription}>
                  {item.description}
                </p>
                <button 
                  className={styles.button}
                  onClick={() => handleButtonClick(idx)}
                >
                  <span className={styles.buttonText}>Подробнее об услуге</span>
                  <svg className={styles.buttonIcon} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.33333 3V4.33333H10.7267L3 12.06L3.94 13L11.6667 5.27333V9.66667H13V3H6.33333Z" fill="currentColor"/>
                  </svg>
                </button>
              </div>
            </div>
          ))}
        </div>
      </AnimatedSection>
    </section>
  )
}

Services.displayName = 'Services'

export default Services